const patched = Symbol("patched");

(function (global) {
  if (
    "BroadcastChannel" in window === false &&
    document[patched] === undefined
  ) {
    let channels = [];
    function BroadcastChannel(channel) {
      let $this = this;
      channel = String(channel);

      let id = "$BroadcastChannel$" + channel + "$";

      channels[id] = channels[id] || [];
      channels[id].push(this);

      this._name = channel;
      this._id = id;
      this._closed = false;
      this._mc = new MessageChannel();
      this._mc.port1.start();
      this._mc.port2.start();

      global.addEventListener("storage", function (e) {
        if (e.storageArea !== global.localStorage) return;
        if (e.newValue === null) return;
        if (e.key.substring(0, id.length) !== id) return;
        let data = JSON.parse(e.newValue);
        $this._mc.port2.postMessage(data);
      });
    }

    BroadcastChannel.prototype = {
      // BroadcastChannel API
      get name() {
        return this._name;
      },
      postMessage: function (message) {
        let $this = this;
        if (this._closed) {
          let e = new Error();
          e.name = "InvalidStateError";
          throw e;
        }
        let value = JSON.stringify(message);

        // Broadcast to other contexts via storage events...
        let key = this._id + String(Date.now()) + "$" + String(Math.random());
        global.localStorage.setItem(key, value);
        setTimeout(function () {
          global.localStorage.removeItem(key);
        }, 500);

        // Broadcast to current context via ports
        channels[this._id].forEach(function (bc) {
          if (bc === $this) return;
          bc._mc.port2.postMessage(JSON.parse(value));
        });
      },
      close: function () {
        if (this._closed) return;
        this._closed = true;
        this._mc.port1.close();
        this._mc.port2.close();

        let index = channels[this._id].indexOf(this);
        channels[this._id].splice(index, 1);
      },

      // EventTarget API
      get onmessage() {
        return this._mc.port1.onmessage;
      },
      set onmessage(value) {
        this._mc.port1.onmessage = value;
      },
      addEventListener: function (type, listener /*, useCapture*/) {
        return this._mc.port1.addEventListener.apply(this._mc.port1, arguments);
      },
      removeEventListener: function (type, listener /*, useCapture*/) {
        return this._mc.port1.removeEventListener.apply(
          this._mc.port1,
          arguments
        );
      },
      dispatchEvent: function (event) {
        return this._mc.port1.dispatchEvent.apply(this._mc.port1, arguments);
      },
    };
  }
  // @ts-ignore: Exists already
  global.BroadcastChannel = global.BroadcastChannel || BroadcastChannel;

  let lastCookie = document.cookie;
  // listen cookie-change messages from other same-origin tabs/frames
  const channel = new global.BroadcastChannel("cookie-channel");
  channel.onmessage = (e) => {
    lastCookie = e.data.newValue;
    document.dispatchEvent(
      new CustomEvent("cookiechange", {
        detail: e.data,
      })
    );
  };

  // rename document.cookie to document._cookie, and redefine document.cookie
  const expando = "_cookie";
  let nativeCookieDesc = Object.getOwnPropertyDescriptor(
    Document.prototype,
    "cookie"
  );
  Object.defineProperty(Document.prototype, patched, {
    value: true,
    writable: false,
    configurable: false,
    enumerable: false,
  });
  Object.defineProperty(Document.prototype, expando, nativeCookieDesc);
  Object.defineProperty(Document.prototype, "cookie", {
    enumerable: true,
    configurable: true,
    get() {
      return this[expando];
    },
    set(value) {
      this[expando] = value;
      // check cookie change
      let cookie = this[expando];
      if (cookie !== lastCookie) {
        try {
          // dispatch cookie-change messages to other same-origin tabs/frames
          let detail = { oldValue: lastCookie, newValue: value };
          this.dispatchEvent(
            new CustomEvent("cookiechange", {
              detail: detail,
            })
          );
          channel.postMessage(detail);
        } finally {
          lastCookie = cookie;
        }
      }
    },
  });
})(self);
